var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "icon-search",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060027424072835371570000014159812652037590174_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 34.5181,
    x2: 17.5,
    y2: 0.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#717272"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060027424072835371570000014159812652037590174_)"
    },
    d: "M16,7.8c0.8,0.8,1.1,1.7,0.7,2.1     c-0.4,0.4-1.4,0.1-2.1-0.7s-1.1-1.7-0.7-2.1C14.3,6.7,15.3,7,16,7.8z M20.4,3.9c3.5,3.5,4.3,8.8,2.4,13.1c0.5,0.5,1.1,1.1,1.7,1.7     c1.1,1.1,0,2.2,0,2.2s8.9,7.6,9,7.7c1.3,1.3,1.3,3.5,0,4.8c-1.3,1.3-3.5,1.3-4.8,0c-0.1-0.1-7.7-9-7.7-9s-1.1,1.1-2.2,0     c-0.7-0.7-1.3-1.3-1.7-1.7c-4.3,1.9-9.5,1.2-13.1-2.4c-4.6-4.6-4.6-11.9,0-16.5C8.5-0.7,15.8-0.7,20.4,3.9z M18,6.3     c-3.2-3.2-8.4-3.2-11.7,0c-3.2,3.2-3.2,8.4,0,11.7c3.2,3.2,8.4,3.2,11.7,0C21.2,14.8,21.2,9.5,18,6.3z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.f294b5c4.svg";
export { ForwardRef as ReactComponent };